/* eslint-disable no-useless-catch */
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/product-certifications';

export const ProductCertificationApi = {
  create: async (body: any) => {
    const url = pathname;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    try {
      const response = await entityService.delete(`${pathname}/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (params: UpdateProductCertification) => {
    const { id, body } = params;

    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateProductCertification {
  option: {
    targetType: string;
  };
  body: any;
}

export interface UpdateProductCertification {
  id: string;
  option: {
    targetType: string;
  };
  body: any;
}
